import { Component, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as fromSeriousSystem from '@serious-system';
import { environment } from '../environments/environment';
import { AnalyticsService } from './analytics/analytics.service';
import * as fromLayout from './layout';

@Component({
  selector: 'squadbox-app-new-release-announcement-card',
  standalone: true,
  imports: [
    fromSeriousSystem.ButtonDirective,
    TranslateModule,
    fromSeriousSystem.UseNavigationIconDirective,
  ],
  template: `
    <div class="flex flex-col gap-1">
      <h3 class="typo-p2 font-semibold ">
        {{
          'NEW_RELEASE_ANNOUNCEMENT_CARD.TITLE'
            | translate: { version: apiReleaseVersion() }
        }}
      </h3>

      <div class="flex flex-col gap-1 typo-p3">
        <p>
          {{ 'NEW_RELEASE_ANNOUNCEMENT_CARD.DESCRIPTION_LINE_1' | translate }}
        </p>
        <p>
          {{ 'NEW_RELEASE_ANNOUNCEMENT_CARD.DESCRIPTION_LINE_2' | translate }}
        </p>
      </div>
    </div>
    <div class="flex flex-wrap justify-between gap-2">
      <a
        class="flex items-center gap-1"
        sdButton
        size="xs"
        color="neutral"
        variant="tonal"
        [href]="whatsNewLink"
        target="_blank"
        rel="noopener noreferrer"
        (click)="handleClickWhatsNewCTA()"
      >
        <svg sdUseNavigationIcon="open-new" class="size-4 shrink-0"></svg>
        <span class="font-normal">{{
          'NEW_RELEASE_ANNOUNCEMENT_CARD.CTA_WHAT_NEW' | translate
        }}</span>
      </a>

      <button sdButton size="xs" (click)="handleClickUpdateCTA()">
        {{ 'NEW_RELEASE_ANNOUNCEMENT_CARD.CTA_UPDATE' | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      @reference '../styles.css';

      :host {
        @apply flex flex-col gap-4;
        @apply px-6 py-4 rounded-3xl;
        @apply bg-shades-white shadow-md;
        @apply border border-neutral-200;
        @apply [view-transition-name:new-release-announcement-card];
      }
    `,
  ],
})
export class AppNewReleaseAnnouncementCardComponent {
  private readonly layoutStore = inject(Store<fromLayout.LayoutState>);
  private readonly translateService = inject(TranslateService);
  private readonly analyticsService = inject(AnalyticsService);

  public readonly apiReleaseVersion = input.required<string>();

  public readonly isMobile = this.layoutStore.selectSignal(
    fromLayout.layoutFeature.selectIsMobile,
  );

  public get whatsNewLink(): string {
    return this.translateService.getCurrentLang() === 'en'
      ? environment.appReleaseNotesUrl.en
      : environment.appReleaseNotesUrl.fr;
  }

  public handleClickWhatsNewCTA() {
    this.analyticsService
      .sendWhatsNewOpenedEvent(this.apiReleaseVersion())
      .subscribe();
  }

  public handleClickUpdateCTA() {
    window.location.reload();
  }
}
